import { onlyMobile } from "@ameelio/ui";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";

export enum WidgetRowLayout {
  TWO_THIRD,
  HALF,
}

export function WidgetRow({
  layout,
  children,
}: {
  layout: WidgetRowLayout;
  children: React.ReactNode;
}) {
  const isMobile = onlyMobile(useMediaQuery);
  const layoutStyle = isMobile
    ? {
        gridTemplateColumns: "1fr",
        gridGap: "16px",
      }
    : layout === WidgetRowLayout.TWO_THIRD
      ? {
          gridTemplateColumns: "2fr 1fr",
          gridGap: "16px",
        }
      : {
          gridTemplateColumns: "1fr 1fr",
          gridGap: "16px",
        };
  return (
    <Box
      sx={{
        display: "grid",
        ...layoutStyle,
        marginBottom: "16px",
      }}
    >
      {children}
    </Box>
  );
}

export function Widget({
  title,
  children,
  value,
}: {
  title: string;
  children?: React.ReactNode;
  value?: string | number;
}) {
  return (
    <Box
      key={title}
      sx={{
        backgroundColor: "white",
        padding: 2,
        borderRadius: 4,
        height: "100%", // Ensure the outer Box takes the full height of its container
      }}
    >
      <Stack
        spacing={2}
        sx={{
          alignItems: "center",
          height: "100%",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: value ? "center" : "flex-start",
            width: "100%",
          }}
        >
          {typeof value !== "undefined" ? (
            <Typography
              sx={{
                fontSize: "4em",
                textDecoration: "none",
                display: "block",
                width: 1,
                textAlign: "center",
                color: "primary.main",
              }}
            >
              {value}
            </Typography>
          ) : (
            children
          )}
        </Box>
        <Typography
          variant="h3"
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {title}
        </Typography>
      </Stack>
    </Box>
  );
}
